export function generateOrganizationSchema () {
  return {
    '@type': 'Organization',
    '@id': 'https://querobolsa.com.br/#organization',
    name: 'Quero Bolsa',
    url: 'https://querobolsa.com.br/',
    logo: 'https://kong.quero.com/logotype-querobolsa.svg',
    sameAs: [
      'https://www.youtube.com/querobolsa',
      'https://www.instagram.com/querobolsa',
      'https://www.twitter.com/querobolsa',
      'https://www.facebook.com/querobolsa',
      'https://www.tiktok.com/@quero.bolsa',
    ],
  }
}
